import { setIsMobileClass } from './isMobile';

export default function () {
  const htmlClassList = document.documentElement.classList;
  htmlClassList.add('js');
  htmlClassList.remove('no-js');
  setIsMobileClass();
}
